export const config = {
  propsName: 'renderProps',
  name: 'SpSelectDate',
  type: 'formTmpsConfig',
  icon: 'el-icon-date',
  cnName: '日期选择',
  base: {
    title: '日期选择',
    //subtitle: 'SpSelect_subtitle',
    padded: true,
    margin: [0, 0, 0, 0],
    selectVal: {
      optionsValue: 'YMD'
    }
  },
  props: [
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '日期选择名称',
        placeholder: '请输入名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },

    {
      type: () => import('@/weappTmps/comps/selectDateType/index.vue'),
      cmpPath: '/comps/selectDateType/index.vue',
      key: 'selectVal',
      bind: {
        label: ''
      },
      value: {
        optionsValue: 'YMD'
      }
    }
  ]
}
